import React, { useEffect, useState } from "react";
import UseInView from "../../components/Generic/UseInView";

const CohortPillar = ({ onClick }) => {
  const parts = [
    "/assets/images/Cohort/1.svg?ver=1",
    "/assets/images/Cohort/2.svg?ver=1",
    "/assets/images/Cohort/3.svg?ver=1",
    "/assets/images/Cohort/4.svg?ver=1",
    "/assets/images/Cohort/5.svg?ver=1",
    "/assets/images/Cohort/6.svg?ver=1",
    "/assets/images/Cohort/7.svg?ver=1",
    "/assets/images/Cohort/8.svg?ver=1",
    "/assets/images/Cohort/9.svg?ver=1",
    "/assets/images/Cohort/10.svg?ver=1",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const [containerRef, inView] = UseInView({ threshold: 0.3 }, false);

  // Preload images
  useEffect(() => {
    let loaded = 0;
    parts.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loaded++;
        if (loaded === parts.length) setImagesLoaded(true);
      };
    });
  }, []);

  // Animate when in view
  useEffect(() => {
    if (!imagesLoaded) return;

    let interval = null;
    if (inView) {
      interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % parts.length);
      }, 1500);
    }

    return () => interval && clearInterval(interval);
  }, [inView, imagesLoaded, parts.length]);

  return (
    <div
      ref={containerRef}
      className="cohort-filler-container"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
      style={{ cursor: "pointer" }}
      aria-label="View cohort description"
    >
      {imagesLoaded ? (
        <img
          src={parts[currentIndex]}
          alt={`Cohort part ${currentIndex + 1}`}
          className="cohort-filler-piece"
        />
      ) : (
        <div className="cohort-placeholder">Loading...</div>
      )}
    </div>
  );
};

export default CohortPillar;
